import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import { Redirect } from 'react-router-dom';
import { ButtonV2, ERROR_STATUS, H2, H3, P, PATH, Spinner, formatPhoneNumber, } from 'shared';
import { useGetConsumerApplicationsV1LocationsSearchQuery, } from 'consumer-applications-v1-api';
function streetLine(location) {
    const { address } = location;
    return [address?.street1, address?.street2].filter(Boolean).join(' ');
}
function cityStateZip(location) {
    const { address } = location;
    const cityState = [address?.city, address?.state].filter(Boolean).join(', ');
    return [cityState, address?.zip].filter(Boolean).join(' ');
}
// Both "location not found" (apiMiddlewareRTK redirects 4xx automatically) and
// "location resolved but PWA-disabled" route to the standard credit-portal
// client error page rather than rendering a custom in-card message.
const CLIENT_ERROR_REDIRECT = `${PATH.CLIENT_ERROR}?status=${ERROR_STATUS.NOT_FOUND}&application=credit-portal`;
function KnownProviderCard({ locationId, onConfirm }) {
    const { data: location, isLoading, isError, } = useGetConsumerApplicationsV1LocationsSearchQuery({ locationId });
    if (isLoading) {
        return (_jsx("div", { className: "pay-with-alphaeon__card", children: _jsx(Spinner, {}) }));
    }
    if (isError || !location || location.pwaEnabled !== true) {
        return _jsx(Redirect, { to: CLIENT_ERROR_REDIRECT });
    }
    return (_jsxs("div", { className: "pay-with-alphaeon__card", children: [_jsx(H2, { variant: "headline-small", className: "mar-b-4", children: "Pay With Alphaeon" }), _jsxs("div", { className: "pay-with-alphaeon__known-provider", children: [_jsxs("div", { className: "pay-with-alphaeon__known-provider-info", children: [_jsx(H3, { variant: "title-medium", bold: true, children: location.name }), _jsx(P, { variant: "body-medium", children: streetLine(location) }), _jsx(P, { variant: "body-medium", children: cityStateZip(location) }), _jsx(P, { variant: "body-medium", children: formatPhoneNumber(location.phone) })] }), _jsx("div", { className: "pay-with-alphaeon__known-provider-cta", children: _jsx(ButtonV2, { color: "red", variant: "filled", onClick: () => onConfirm(location), children: "Pay With Alphaeon" }) })] })] }));
}
export default memo(KnownProviderCard);
